import { render, staticRenderFns } from "./prjSelectRefComponentDialog.vue?vue&type=template&id=20133bf4"
import script from "./prjSelectRefComponentDialog.vue?vue&type=script&lang=js"
export * from "./prjSelectRefComponentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports